import { Component } from "@angular/core";
import { LocalstorageProvider } from "providers/localstorage/localstorage";
import { TranslateService } from "@ngx-translate/core";
import { RemoteServicesProvider } from "providers/remote-services/remote-services";
import { LoginProvider } from "providers/login/login";
import { PopupMessage, MessageService } from "rb-core-library";


/**
 * Generated class for the SyncBarComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: "sync-bar",
    templateUrl: "sync-bar.component.html",
    styleUrls: ['sync-bar.component.scss']
})
export class SyncBarComponent {
    text: string;
    isSyncing: boolean = false;
    showConfirmation: boolean = false;

    constructor(
        private localStorageProvider: LocalstorageProvider,
        private translateService: TranslateService,
        private remoteServicesProvider: RemoteServicesProvider,
        private loginProvider: LoginProvider,
        public messageService: MessageService
    ) { 
        this.messageService.popupMessage = null;
    }

    async resync() {
        this.isSyncing = true;
        let keys = this.localStorageProvider.getPosKeys();

        for (let i = 0; i < keys.length; i++) {
            let key = keys[i];
            let data = this.localStorageProvider.read(key);
            let serverError = false;

            let doSync = await this.remoteServicesProvider
                .sendSpot(data, this.loginProvider.token)
                .catch(err => {
                    let popupMessage: PopupMessage = {
                        type: 'danger',
                        text: this.translateService.instant(err.status === '401' ? "App.AccessDenied" : "App.GenericError"),
                        timeout: 3000
                    };
                    this.messageService.addMessage(popupMessage);

                    serverError = true;
                });

            if (doSync) {
                this.localStorageProvider.remove(key);
            }

            if (serverError) {
                break;
            }
        }

        this.isSyncing = false;
    }

    hasItemsToSync() {
        return this.localStorageProvider.getCountPosKey() > 0;
    }

    presentConfirm() {
        this.showConfirmation = true;
    }

    discard() {
        this.localStorageProvider.clear();
        this.hide();
    }
    hide() {
        this.showConfirmation = false;
    }
}
